import React from 'react';
import { Form } from 'antd';
import PropTypes from 'prop-types';

import OnTraccrTextInput from './OnTraccrTextInput';
import DisplayText from '../text/DisplayText';
import AddressLink from '../text/AddressLink';

const formStyle = { marginBottom: 0, paddingBottom: -8 };
const formLabelStyle = {
  style: {
    paddingBottom: 5,
    marginTop: 10,
  },
};

function FormTextInput({
  isNotDisplay,
  label,
  name,
  value,
  rules,
  textarea,
  autoSize,
  placeholder,
  password,
  textProps,
  style,
  supportMultiLine,
  isAddress,
}) {
  let display;
  if (isAddress) {
    display = <AddressLink address={value} />;
  } else {
    display = <DisplayText title={value} supportMultiLine={supportMultiLine} />;
  }

  return (
    <Form.Item
      name={name}
      label={label}
      style={{ ...formStyle, ...style }}
      labelCol={formLabelStyle}
      rules={rules}
    >
      {isNotDisplay
        ? (
          <OnTraccrTextInput
            textarea={textarea}
            autoSize={autoSize}
            placeholder={placeholder}
            password={password}
            {...textProps}
          />
        )
        : display}
    </Form.Item>
  );
}

/* eslint-disable react/forbid-prop-types */
FormTextInput.propTypes = {
  isNotDisplay: PropTypes.bool,
  label: PropTypes.node,
  name: PropTypes.string,
  value: PropTypes.string,
  rules: PropTypes.array,
  textarea: PropTypes.bool,
  autoSize: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  placeholder: PropTypes.string,
  password: PropTypes.bool,
  textProps: PropTypes.object,
  style: PropTypes.object,
  supportMultiLine: PropTypes.bool,
  isAddress: PropTypes.bool,
};

FormTextInput.defaultProps = {
  isNotDisplay: false,
  label: null,
  name: undefined,
  value: null,
  rules: [],
  textarea: false,
  autoSize: false,
  placeholder: null,
  password: false,
  textProps: {},
  style: {},
  supportMultiLine: false,
  isAddress: false,
};

export default FormTextInput;
